import { z, ZodType } from 'zod';
import { UserRole, userRolesSchema } from './user-role';

export type AuthDto = {
	id: number;
	accountId: number;
	cashdeskId: number | null;
	name: string;
	role: UserRole;
	token: string;
};

export const AuthDtoSchema: ZodType<AuthDto> = z.object({
	id: z.number(),
	accountId: z.number(),
	cashdeskId: z.number().nullable(),
	name: z.string(),
	role: userRolesSchema,
	token: z.string(),
});
